'use client';

type PlatformSelectorProps = {
  selectedPlatforms: string[];
  onTogglePlatform: (platform: string) => void;
  label?: string;
};

const AVAILABLE_PLATFORMS = [
  { id: 'linkedin', name: 'LinkedIn' },
  { id: 'twitter', name: 'Twitter' },
  { id: 'facebook', name: 'Facebook' },
  { id: 'instagram', name: 'Instagram' },
];

export const PlatformSelector = ({ 
  selectedPlatforms, 
  onTogglePlatform, 
  label = "Select platforms for content generation:" 
}: PlatformSelectorProps) => {
  return (
    <div className="mb-4">
      <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
        {label}
      </label>
      <div className="grid grid-cols-2 gap-2">
        {AVAILABLE_PLATFORMS.map((platform) => (
          <button
            key={platform.id}
            onClick={() => onTogglePlatform(platform.id)}
            className={`flex items-center justify-center rounded-lg border px-3 py-2 text-sm font-medium transition-colors ${
              selectedPlatforms.includes(platform.id)
                ? 'border-blue-500 bg-blue-50 text-blue-700 dark:border-blue-400 dark:bg-blue-900/20 dark:text-blue-300'
                : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
            }`}
          >
            <span className="capitalize">{platform.name}</span>
            {selectedPlatforms.includes(platform.id) && (
              <span className="ml-1 text-xs">✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};
